import Treatments from './Treatments';

export default Treatments;
